import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

import type { PaidSponsorTag } from "@shared/types/PaidSponsorTag";

export interface InternalAdTrackingDataParams {
  campaign_id: number;
  campaign_content_ad_type: string;
  campaign_content_id: number;
  campaign_segment_id: number;
  contract_id: string;
  placement_id: number;
  placement_label?: string;
  placement_name: string;
  placement_page_name: string;
  placement_value?: string;
  sponsor_tags: PaidSponsorTag[];
}

export class InternalAdTrackingData extends BaseEntityClass {
  ad_type: string;
  campaign_id: number;
  campaign_content_id: number;
  campaign_segment_id: number;
  contract_id: string;
  placement_id: number;
  placement_label?: string;
  placement_name: string;
  placement_page_name: string;
  placement_value?: string;
  sponsors: PaidSponsorTag[];

  constructor(params: InternalAdTrackingDataParams) {
    super();
    this.campaign_id = params.campaign_id;
    this.campaign_content_id = params.campaign_content_id;
    this.ad_type = params.campaign_content_ad_type;
    this.campaign_segment_id = params.campaign_segment_id;
    this.contract_id = params.contract_id;
    this.placement_id = params.placement_id;
    this.placement_label = params.placement_label;
    this.placement_name = params.placement_name;
    this.placement_page_name = params.placement_page_name;
    this.placement_value = params.placement_value;
    this.sponsors = params.sponsor_tags;
  }
}
